<div class="btn-group">
    <button class="btn btn-secondary" data-toggle="dropdown" type="button" hznTestId="sort-field-button">
        Sort by {{ model.fieldName }}
    </button>
    @if (isByAsc()) {
        <button
            type="button"
            hznTestId="sort-descending-button"
            (click)="sortByDesc()"
            class="btn btn-secondary dropdown-toggle dropdown-toggle-split"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sr-only">Sort descending</span>
        </button>
    }
    @if (isByDesc()) {
        <button
            type="button"
            hznTestId="sort-ascending-button"
            (click)="sortByAsc()"
            class="btn btn-secondary dropdown-toggle dropdown-toggle-split sort-up"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sr-only">Sort ascending</span>
        </button>
    }
    <div class="dropdown-menu">
        @for (item of sorting; track item) {
            <button class="dropdown-item" hznTestId="sort-option" (click)="setOrder(item)">
                By {{ item }}
            </button>
        }
    </div>
</div>
